@if (
  (displayUsage && usageData) ||
  (displayWOSCitation && wosCitationTotal > 0) ||
  (displayScopusCitation && (scopusCitationTotal$ | async) > 0)
  ) {
  <div
    class="metrics"
    >
    @if (displayUsage && usageData) {
      <div class="usage">
        @if (usageData.downloads > 0) {
          <div class="metric-section">
            <mat-icon svgIcon="download"></mat-icon>
            <span class="padding-left-xs">
              <span>{{ usageData.downloads }} </span>
              <span>{{ 'research.portal.fulldisplay.metrics.fileViewsDownloads' | translate }}</span>
            </span>
          </div>
        }
        <div class="metric-section">
          <mat-icon svgIcon="eye-outline"></mat-icon>
          <span class="padding-left-xs">
            <span>{{ usageData.views }} </span>
            <span>{{ 'research.portal.fulldisplay.metrics.recordViews' | translate }}</span>
          </span>
        </div>
      </div>
    }
    @if (displayWOSCitation && wosCitationTotal > 0) {
      <div class="metric-section">
        <span class="citation-icon">
          <mat-icon class="mat-icon-rtl-mirror" svgIcon="message-text"></mat-icon>
          @if (displayCitationSrcIcon) {
            <mat-icon class="citation-source-icon" svgIcon="clarivate-mono-square" muloSvgViewbox></mat-icon>
          }
        </span>
        <span class="padding-left-xs">
          @if (wosIdentifier()) {
            <a
              [href]="getLink()"
              attr.aria-label="{{ 'research.aria.wos.link' | translate }}"
              target="_blank"
              >
              <span>{{ wosCitationTotal }} </span>
              <span>{{ 'research.portal.fulldisplay.metrics.wos' | translate }}</span>
            </a>
          }
          @if (!wosIdentifier()) {
            <span>{{ wosCitationTotal }} </span>
            <span>{{ 'research.portal.fulldisplay.metrics.wos' | translate }}</span>
          }
        </span>
      </div>
    }
    @if (displayScopusCitation) {
      @if (scopusCitationTotal$ | async; as scopusCitationTotal) {
        <div class="metric-section">
          <span class="citation-icon">
            <mat-icon class="mat-icon-rtl-mirror" svgIcon="message-text"></mat-icon>
            @if (displayCitationSrcIcon) {
              <mat-icon class="citation-source-icon" svgIcon="scopus-square" muloSvgViewbox></mat-icon>
            }
          </span>
          <span class="padding-left-xs">
            <span>{{ scopusCitationTotal }} </span>
            <span>{{ 'research.portal.fulldisplay.metrics.scopus' | translate }}</span>
          </span>
        </div>
      }
    }
  </div>
}

@if (displayAltmetrics && doi) {
  <div class="altmetrics-wrapper margin-top-sm">
    <div
      attr.data-doi="{{ doi }}"
      class="altmetric-embed"
      data-badge-details="right"
      data-badge-type="donut"
      data-hide-no-mentions="true"
      data-link-target="_blank"
    ></div>
  </div>
}
